import { Button, Spinner, Wrap } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { CourseTema } from "../../const/types";
import cr from "../../lib/request";
import useTemaAllCourses from "../../globalState/useTemaAllCourses";
import { useNavigate } from "react-router-dom";

export default function PopularTema() {
  const [data, setData] = useState<CourseTema[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { setTema } = useTemaAllCourses();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const url = `api/course/theme/popularthemes`;
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return !loading && data ? (
    <Wrap flex={1} gap={0}>
      {data.map((tema, i) => (
        <Button
          key={i}
          colorScheme="ap"
          variant={"ghost"}
          onClick={() => {
            setTema(tema);
            navigate("/allcourses");
          }}
        >
          {tema.theme_name}
        </Button>
      ))}
    </Wrap>
  ) : (
    <Spinner size={"sm"} my={"auto"} />
  );
}
